import script from "./BookingVerifyError.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingVerifyError.vue?vue&type=script&setup=true&lang=js"

import "./BookingVerifyError.vue?vue&type=style&index=0&id=7423963a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7423963a"]])

export default __exports__